
import './App.css';
import Header from './Component/Header/Header';
import Writers from './Component/Writers/Writers';

function App() {


  return (
    <div>
     <Header></Header>
     <Writers></Writers>
    </div>
  );
}

export default App;
